import {onLoad} from "../base/onLoad";

onLoad(() => {
    const elements = document.querySelectorAll('[data-has-scrolled]');
    elements.forEach(i => new HasScrolled(i as HTMLElement));
});

class HasScrolled {
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;

        this.initElement();
        this.initListeners();
    }

    initElement() {
        this.element.setAttribute('data-has-scrolled', 'false');
    }

    initListeners() {
        window.addEventListener('scroll', this.onScroll.bind(this));
        this.onScroll();
    }

    onScroll() {
        if (window.scrollY > 0) {
            this.element.setAttribute('data-has-scrolled', 'true');
        } else {
            this.element.setAttribute('data-has-scrolled', 'false');
        }
    }
}